module.exports = __webpack_public_path__ + "b8c40e6cb29381340a7cd7be44e56244.woff";